import { Col, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import Typography from '../../shared/typography/Typography';
import { TypeColorNames } from '../../../theme/colors';
import { ChannelContext } from '../../../context/channel';
import NewsletterSVGDots from '../../dashboard/NewletterSVGDots';
import TrianglesIcon from '../../shared/Icons/TrianglesIcon';
import Button from '../../shared/button/Button';
import LeftArrowIcon from '../../shared/Icons/LeftArrowIcon';
import CustomInput from '../CustomInput';
import { t } from 'i18next';

interface StyledNewsletterProps {
  style?: any;
  colorPrimary: TypeColorNames;
  colorSecondary: TypeColorNames;
}

export interface INewsletter {
  style?: any;
  colorPrimary: TypeColorNames;
  colorSecondary: TypeColorNames;
  title: string;
  description: string;
  onClick?: any;
  onChange?: any;
  setEmailNewsletter?: React.Dispatch<React.SetStateAction<string>>;
  idForAnchor?: string;
}

const DEFAULT_COLOR = 'title';

const StyledNewsletter = styled.div<StyledNewsletterProps>`
  background-color: ${(props) => props.colorPrimary};
   
  padding: 56px 0 48px 0;
  height: 380px;

  @media only screen and (max-width: 768px) {
    padding: 10px;
    background-image: none;
  }

  .newsletterSVGDots-container {
    margin-left: 150px;

    @media only screen and (max-width: 768px) {
      margin-left: 50px;
    }
  }

  .title{
    display: flex;
    justify-content: center;
    padding: 15px;
    margin-left: 30px;
  }

  .description {
    display: flex;
    justify-content: center;
  }

  .center{
      text-align: center;
  }

  .email-input {
    display: flex;
    justify-content: center;
  }

  .form{
      padding: 15px;
      display: flex;
      margin-left: 150px;
      align-self: center;

      @media only screen and (max-width: 768px) {
        margin-left: 50px;
      }

      .ant-input{
        height: 56px;
      }

      .eventials-button{
        margin-top: 0px !important;
        padding: 0 ;
      }
  }
`;

const CentralContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
`;

const Newsletter = ({
  style,
  colorPrimary,
  colorSecondary,
  title,
  description,
  onClick,
  onChange,
  setEmailNewsletter,
  idForAnchor,
}: INewsletter) => {
  const {data} = React.useContext(ChannelContext);

  const handleChange = (e: any) => {
    if (setEmailNewsletter !== undefined) {
      setEmailNewsletter(e.target.value)
    }
  }

  const onPressEnter = (e: any) => {
    if(e.key === 'Enter' && setEmailNewsletter !== undefined) {
      onClick()
    }
  }

   return (
    <StyledNewsletter
      colorPrimary={colorPrimary}
      colorSecondary={colorSecondary}
      style={{ ...style }}
      id={idForAnchor}
    >
      {!data.hiddenIcons && 
        <Row className="newsletterSVGDots-container">
          <NewsletterSVGDots colorSecondary={colorSecondary} />
        </Row>
      }
      <CentralContainer>
      <Row className="title">
        <Col xs={18} lg={18} xl={{ span: 12, offset: 4 }} className="center">
          <Typography type="heading4" color="white">
            {title}
          </Typography>
        </Col>
        {!data.hiddenIcons && 
          <Col
            xs={{ span: 2, offset: 1 }}
            md={{ span: 3, offset: 1 }}
            lg={{ span: 2, offset: 1 }}
            xl={{ span: 2, offset: 2 }}
          >
            <TrianglesIcon colorSecondary={colorSecondary} />
          </Col>
        }
      </Row>
      <Row style={{ paddingLeft: '20px'}} className="description">
        <Col xs={20} lg={20} className="center">
          <Typography type="titleNormal3" color="white">
            {description}
          </Typography>
        </Col>
      </Row>
      <Row className="email-input">
        <Col
          xs={{ span: 20 }}
          md={{ span: 12 }}
          lg={{ span: 10 }}
          xl={{ span: 8 }}
          className="form"
        >
          <CustomInput
            borderRadius={40}
            style={{ width: '70%' }}
            placeholderText={t("newsletter.email.placeholder")!}
            color={colorSecondary}
            onChange={(e: any) => handleChange(e)}
            onPressEnter={(e: any) => onPressEnter(e)}
          />
          <Button
            variant="text"
            colorType="secondary"
            onClick={onClick}
            enable
            style={{border: 'none'}}
            leftIcon={
              <LeftArrowIcon colorSecondary={colorSecondary} />
            }
          />
        </Col>
      </Row>
      {!data.hiddenIcons && 
      <Row>
        <Col
          xs={{ span: 8, offset: 8 }}
          sm={{ span: 8, offset: 10 }}
          md={{ span: 6, offset: 17 }}
          lg={{ span: 4, offset: 18 }}
          xl={{ span: 4, offset: 18 }}
        >
          <NewsletterSVGDots colorSecondary={colorSecondary} />
        </Col>
      </Row>
      }
      </CentralContainer>
    </StyledNewsletter>
  );
};

Newsletter.defaultProps = {
  colorPrimary: DEFAULT_COLOR,
};

export default Newsletter;
